import _ from 'lodash';

import { COMMON_SETTINGS_RESPONSE_KEYS_MAP, CommonSettingsKeys, CommonSettingsResponseKeys } from '../constants';
import {
    BalanceCommonSettings,
    CommonSettings,
    CommonSettingsResponse,
    CommonSettingsUnionKeys,
    FieldData,
    OrderPriorityCommonSettings,
    TeamLeadCommissionCommonSettings
} from '../entities';

export const _getSettingsResult = <T>(settings: FieldData[]): T => {
    const result = {} as any;

    settings.forEach((setting) => {
        const key = _.last(setting?.code?.split('.') ?? []) as CommonSettingsResponseKeys;

        result[COMMON_SETTINGS_RESPONSE_KEYS_MAP[key]] = setting.value;
    });

    return result;
};

export const getCommonSettingsTransformedData = (settings: CommonSettingsResponse): CommonSettings => {
    const orderPrioritySettings = _getSettingsResult<OrderPriorityCommonSettings>(settings.orderPrioritySettings);
    const balanceSettings = _getSettingsResult<BalanceCommonSettings>(settings.balanceSettings);
    const teamLeadCommissionSettings = _getSettingsResult<TeamLeadCommissionCommonSettings>(
        settings.teamLeadCommissionSettings
    );

    return {
        orderPrioritySettings,
        balanceSettings,
        teamLeadCommissionSettings
    };
};

export const getCommonSettingsCollectedData = (settings: CommonSettingsUnionKeys): CommonSettings => {
    const orderPrioritySettings = {
        [CommonSettingsKeys.TraderOrderShare]: settings[CommonSettingsKeys.TraderOrderShare],
        [CommonSettingsKeys.NewTraderOrderShare]: settings[CommonSettingsKeys.NewTraderOrderShare],
        [CommonSettingsKeys.OperatorOrderShare]: settings[CommonSettingsKeys.OperatorOrderShare]
    };
    const balanceSettings = {
        [CommonSettingsKeys.MinTrustBalance]: settings[CommonSettingsKeys.MinTrustBalance],
        [CommonSettingsKeys.MinTradeBalance]: settings[CommonSettingsKeys.MinTradeBalance]
    };
    const teamLeadCommissionSettings = {
        [CommonSettingsKeys.TeamLeadPayinCommissionRate]: settings[CommonSettingsKeys.TeamLeadPayinCommissionRate],
        [CommonSettingsKeys.TeamLeadPayoutCommissionRate]: settings[CommonSettingsKeys.TeamLeadPayoutCommissionRate]
    };

    return {
        orderPrioritySettings,
        balanceSettings,
        teamLeadCommissionSettings
    };
};
